import React from 'react';

function Video(props) {
    const { item = {} } = props;
    const { settings = {} } = item;
    if (settings.type !== 'embed') {
        return <HTMLVideo {...props} />;
    } else {
        return <EmbedVideo {...props} />;
    }
}

export default Video;

function HTMLVideo({ className, item }) {
    const { sources = {}, attr = {} } = item;
    const items = Object.entries(sources).filter(([key, value]) => value);
    const autoplay = attr.autoplay ? true : null;
    const controls = attr.controls !== undefined ? attr.controls : true;

    return (
        <video
            {...attr}
            controls={controls}
            autoPlay={autoplay}
            className={className}
            poster={!items.length && '/assets/images/video-placeholder.jpg'}
        >
            {items.map(([key, src]) => (
                <source key={key} src={src} type={`video/${key}`}></source>
            ))}
            Your browser doesn't support HTML5 video tag.
        </video>
    );
}

function EmbedVideo(props) {
    const { className, item = {} } = props;
    const { attr = {}, settings = {} } = item;
    let embedUrl = formatIframeSrc(settings.url);
    const query = getQueryString(attr);
    embedUrl += embedUrl ? `?${query}` : '';
    if (!embedUrl)
        return (
            <img
                src="/assets/images/video-placeholder.jpg"
                alt="video placeholder"
            />
        );
    return (
        <div className={`dorik-iframe ${className}`}>
            <iframe
                title={item.id}
                src={embedUrl}
                frameBorder="0"
                allow={getAllowPropString(attr)}
                allowFullScreen={attr.fullscreen}
            ></iframe>
        </div>
    );
}

function formatIframeSrc(url = '') {
    if (/vimeo/.test(url)) {
        const video = url.match(/vimeo\.com\/(\d+)/);
        return video ? `https://player.vimeo.com/video/${video[1]}` : '';
    } else if (/youtu(be)?\.(com|be)/.test(url)) {
        const ytRegx = /(.*?)(^|\/|v=)([a-z0-9_-]{11})/i;
        const video = url.match(ytRegx);
        return video ? `https://www.youtube.com/embed/${video[3]}` : '';
    } else {
        return url;
    }
}

function getQueryString(item = {}) {
    const options = {
        fs: item.fullscreen !== undefined ? item.fullscreen : 1,
        muted: item.muted ? 1 : 0,
        loop: item.loop ? 1 : 0,
        autoplay: item.autoplay ? 1 : 0,
        controls: item.controls !== undefined ? item.controls : 1,
    };

    return Object.entries(options)
        .map(([key, value]) => `${key}=${Number(value)}`)
        .join('&');
}

function getAllowPropString(item) {
    const options = {
        autoplay: item.autoplay,
        fullscreen: item.fullscreen,
    };
    return Object.entries(options)
        .filter(([key, val]) => val)
        .map(([key]) => key)
        .join(';');
}
